import { PropsWithChildren } from "react";
import { Flex, FlexProps, Span } from "@goodfill/ui-components";
import "./Info.scss";

type InfoProps = PropsWithChildren<
  Pick<FlexProps, "justify"> & {
    label: string;
    // should the value text be wrapped if it doesn't fit
    valueTextWrap?: boolean;
    className?: string;
    marginTopCustom?: string;
  }
>;

export const Info: React.FC<InfoProps> = ({ children, justify, label, valueTextWrap, className, marginTopCustom }) => {
  return (
    <div className={`flex my-1 md:my-2 flex-col md:flex-row justify-between gap-5 md:gap-9 ${className}`}>
      <div className="flex detail-item">
        <Span font="light" size="sm" className="break-word whitespace-unset-important">
          {label}
        </Span>
      </div>
      <Flex justify={justify} className={`detail-item ${marginTopCustom}`}>
        <Span font="medium" wrap={valueTextWrap} size="sm" className="break-word whitespace-unset-important">
          {children}
        </Span>
      </Flex>
    </div>
  );
};
